import routes from 'routes'
import { Pages } from 'routes/types'

export const getRoutePath = (page: Pages) => routes[page]?.path?.replace(/\/\*$/, '')
